<form (keydown.enter)="$event.preventDefault()" [formGroup]="formGroup" class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="content-container">
    <div class="content">
      <p>The Orbitax Demo gives you a temporary work space where you are free to explore the available solutions and to
        test file imports and features in a standalone test environment.</p>
      <p>The demo will run for 2 hours or until you choose to exit (via the user drop-down in the top right corner), at
        which point you will be returned to your regular company and projects.</p>
      <p><strong>To begin, just type a few words on why you are using this demo.
        We will use this information to assist you should you need any help.</strong></p>
    </div>
    <img src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/modal-demo.png" alt="demo-image">
  </div>

  <div class="m-t-20 flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-0-0-100">
      <mat-label>Select Demo</mat-label>
      <mat-select formControlName="demo">
        <mat-option attr.data-cy="{{demo.title}}" *ngFor="let demo of (demos$ | async)" [value]="demo">
          {{demo.title}}
        </mat-option>_
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex flex-row justify-start items-start auto-flex" >
    <mat-form-field appearance="outline" style="margin-bottom: 0;flex-grow:1">
      <mat-label>Comment</mat-label>
      <textarea matInput type="text" [(ngModel)]="comment" formControlName="comment"
                placeholder="Enter comment..."  rows="5">

      </textarea>
    </mat-form-field>
  </div>
</form>



<!--<div class="w-n-600" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto">
    <mat-form-field appearance="outline" fxFlex="0 0 100" >
      <mat-label>OECD Legal Address Type*</mat-label>
      <mat-select formControlName="demo">
        <mat-option>
          demo.title
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto">
    <mat-form-field appearance="outline" fxFlex="0 0 100" >
      <mat-label>Country for address*</mat-label>
      <mat-select formControlName="demo">
        <mat-option>
          Australia
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <mat-slide-toggle class="m-b-10"></mat-slide-toggle>

  <div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto" >
  <mat-form-field appearance="outline" class="w-p-100">
    <mat-label>Street</mat-label>
    <input matInput  placeholder="Street" />
  </mat-form-field>
</div>
  <div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto" >
    <mat-form-field appearance="outline" class="w-p-100">
      <mat-label>Building</mat-label>
      <input matInput  placeholder="Building" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto" >
    <mat-form-field appearance="outline" class="w-p-100">
      <mat-label>Suite</mat-label>
      <input matInput  placeholder="Suite" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto" >
    <mat-form-field appearance="outline" class="w-p-100">
      <mat-label>Floor</mat-label>
      <input matInput  placeholder="Floor" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto" >
    <mat-form-field appearance="outline" class="w-p-100">
      <mat-label>District</mat-label>
      <input matInput  placeholder="District" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto" >
    <mat-form-field appearance="outline" class="w-p-100">
      <mat-label>Post Office Box</mat-label>
      <input matInput  placeholder="Post Office Box" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto" >
    <mat-form-field appearance="outline" class="w-p-100">
      <mat-label>Post Code *</mat-label>
      <input matInput  placeholder="Post Code" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto" >
    <mat-form-field appearance="outline" class="w-p-100">
      <mat-label>City *</mat-label>
      <input matInput  placeholder="City" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto" >
    <mat-form-field appearance="outline" class="w-p-100">
      <mat-label>Sub Enity *</mat-label>
      <input matInput  placeholder="Sub Enity" />
    </mat-form-field>
  </div>
  <mat-slide-toggle class="m-b-10"></mat-slide-toggle>

  <div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto" >
    <mat-form-field appearance="outline" class="w-p-100">
      <mat-label>Address</mat-label>
      <input matInput  placeholder="Address" disabled="true" />
    </mat-form-field>
  </div>
</div>-->
